import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";

export const countCampaignEngagements = (campaignId: number): Promise<number> => {
    return AxiosClientFactory
        .getInstance()
        .get<number>(`/api/campaigns/${campaignId}/engagements/count`)
        .then((response) => response.data);
}